module.exports = __webpack_public_path__ + "img/洛洛店主v2.e5ec2771.png";